<template>
  <div class="container">
    <ball-triangle-path-loader
      class="center"
      color="#000000"
      size="20px"
    ></ball-triangle-path-loader>
  </div>
</template>

<script>
export default {
  name: "triangleLoader",
};
</script>

<style scoped>
.container {
  min-height: 350px;
  position: relative;
}
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>